// Mock data for ElevatED Education Consulting Website

export const heroData = {
  title: "Your Journey to Academic Excellence Starts Here",
  subtitle: "Expert guidance for students pursuing higher education in Canada and beyond",
  ctaText: "Book Free Consultation",
  secondaryCtaText: "Explore Programs",
  backgroundImage: "https://images.unsplash.com/photo-1758270704524-596810e891b5"
};

export const servicesData = [
  {
    id: 1,
    icon: "GraduationCap",
    title: "College Admissions",
    description: "Navigate the complex admissions process with personalized guidance from application to acceptance."
  },
  {
    id: 2,
    icon: "MapPin",
    title: "Career Path Planning",
    description: "Discover your ideal program and career trajectory with expert counseling tailored to your goals."
  },
  {
    id: 3,
    icon: "Home",
    title: "Domestic Student Support",
    description: "Dedicated guidance for Canadian residents — from provincial student aid to high-school transitions and adult learner re-entry."
  },
  {
    id: 4,
    icon: "FileText",
    title: "Application Assistance",
    description: "Professional help with essays, documents, and application strategies to maximize your chances."
  },
  {
    id: 5,
    icon: "Users",
    title: "One-on-One Mentorship",
    description: "Personalized mentorship throughout your entire educational journey from start to finish."
  },
  {
    id: 6,
    icon: "Award",
    title: "Scholarship Guidance",
    description: "Identify and apply for scholarships and financial aid opportunities to fund your education."
  }
];

export const howItWorksData = [
  {
    step: 1,
    title: "Free Consultation",
    description: "Book a complimentary session with our education experts to discuss your goals and aspirations.",
    icon: "Calendar"
  },
  {
    step: 2,
    title: "Personalized Plan",
    description: "Receive a customized roadmap tailored to your academic background and career objectives.",
    icon: "ClipboardList"
  },
  {
    step: 3,
    title: "Application Support",
    description: "Get expert guidance through every step of the application process with dedicated support.",
    icon: "FileCheck"
  },
  {
    step: 4,
    title: "Success & Beyond",
    description: "Secure your admission and receive ongoing support as you begin your academic journey.",
    icon: "TrendingUp"
  }
];

export const partnerInstitutions = [
  {
    id: 1,
    name: "Cambria College",
    slug: "cambria-college",
    location: "Victoria, Surrey, Richmond & Vancouver, BC",
    programs: 5,
    specialization: "Healthcare & Business",
    image: "https://images.unsplash.com/photo-1595760867694-fd5132a92955?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb2xsZWdlJTIwYnVpbGRpbmclMjBjYW1wdXMlMjBDYW5hZGF8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Career-focused training in Healthcare, Business, Hospitality, and IT since 2005"
  },
  {
    id: 2,
    name: "Granville College",
    slug: "granville-college",
    location: "Vancouver & Surrey, BC",
    programs: 5,
    specialization: "Veterinary & Healthcare",
    image: "https://images.unsplash.com/photo-1724502555813-9ea4fe5d9c1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb2xsZWdlJTIwYnVpbGRpbmclMjBjYW1wdXMlMjBDYW5hZGF8ZW58MHx8fHwxNzc3NTkxMzk0fDA&ixlib=rb-4.1.0&q=85",
    description: "Established in 1982, Canada's first Veterinary Technician Assistant College"
  },
  {
    id: 3,
    name: "Swenam College",
    slug: "swenam-college",
    location: "British Columbia",
    programs: 4,
    specialization: "Business & Sciences",
    image: "https://images.unsplash.com/photo-1724502555871-b4e079027344?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb2xsZWdlJTIwYnVpbGRpbmclMjBjYW1wdXMlMjBDYW5hZGF8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Research and career training in Business, Sciences, Psychology, and Nutrition"
  },
  {
    id: 5,
    name: "VCCT",
    slug: "vcct",
    location: "Vancouver, BC",
    programs: 5,
    specialization: "Counselling & Mental Health",
    image: "https://images.unsplash.com/photo-1769209435699-9cc1fd8e7f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwQnJpdGlzaCUyMENvbHVtYmlhJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Vancouver College of Counsellor Training - Specialized counselling and mental health programs"
  },
  {
    id: 6,
    name: "Avalon Community College",
    slug: "avalon-community-college",
    location: "Surrey, BC",
    programs: 5,
    specialization: "Business & Hospitality",
    image: "https://images.unsplash.com/photo-1745558852855-9f9e34017226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwQnJpdGlzaCUyMENvbHVtYmlhJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Quality education in Business, Healthcare, Hospitality, and Veterinary fields"
  },
  {
    id: 7,
    name: "Eton College",
    slug: "eton-college",
    location: "Vancouver, BC",
    programs: 5,
    specialization: "Aviation & Hospitality",
    image: "https://images.unsplash.com/photo-1745558858213-c1bb66fc8fde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwQnJpdGlzaCUyMENvbHVtYmlhJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Excellence in Travel, Tourism, Hospitality, Business, Flight Attendant, and IT since 2003"
  },
  {
    id: 8,
    name: "Multihexa College",
    slug: "multihexa-college",
    location: "Vancouver, BC",
    programs: 5,
    specialization: "Technology & IT",
    image: "https://images.unsplash.com/photo-1635295852796-f6867d868156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwQnJpdGlzaCUyMENvbHVtYmlhJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Career-focused programs in digital technology and IT with 20+ years of experience"
  },
  {
    id: 9,
    name: "Taylor Pro College",
    slug: "taylor-pro-college",
    location: "Vancouver, Vernon & Kelowna, BC",
    programs: 5,
    specialization: "Transportation & Business",
    image: "https://images.unsplash.com/photo-1724502555871-b4e079027344?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb2xsZWdlJTIwYnVpbGRpbmclMjBjYW1wdXMlMjBDYW5hZGF8ZW58MHx8fHwxNzc3NTkxMzk1fDA&ixlib=rb-4.1.0&q=85",
    description: "Academic programs, micro-credentials, and driver training programs for market demand"
  }
];

export const successStories = [
  {
    id: 1,
    name: "Sarah Thompson",
    program: "Health Care Assistant, Cambria College",
    country: "Canada",
    initials: "ST",
    testimonial: "I didn't really know where to start at first but Elevated Education helped me figure everything out step by step. Made the whole process way less stressful.",
    rating: 5,
    date: "2025-11-15"
  },
  {
    id: 2,
    name: "Michael Chen",
    program: "Digital Business Management, Cambria College",
    country: "Canada",
    initials: "MC",
    testimonial: "Honestly really helpful. I had a lot of questions and they always got back to me pretty quick. Felt like they actually cared.",
    rating: 5,
    date: "2025-10-22"
  },
  {
    id: 3,
    name: "Emily Martinez",
    program: "Professional Counselling, VCCT",
    country: "Canada",
    initials: "EM",
    testimonial: "The application process seemed confusing at first but they explained it in a way that actually made sense. Glad I found them.",
    rating: 5,
    date: "2025-09-30"
  },
  {
    id: 4,
    name: "David Wilson",
    program: "Culinary Arts, ACC",
    country: "Canada",
    initials: "DW",
    testimonial: "Good experience overall. They helped me pick a program that actually fits what I want to do, not just anything.",
    rating: 5,
    date: "2025-12-05"
  },
  {
    id: 5,
    name: "Jennifer Patel",
    program: "Veterinary Technician Assistant, Granville College",
    country: "Canada",
    initials: "JP",
    testimonial: "I booked a free consultation with Elevated Education just to see and it ended up being really useful. Gave me a clear idea of what I need to do next.",
    rating: 5,
    date: "2025-08-18"
  },
  {
    id: 6,
    name: "Robert Anderson",
    program: "Business Administration, ACC",
    country: "Canada",
    initials: "RA",
    testimonial: "Wasn't sure if I needed help at first but I'm glad I went with Elevated Education. They made things easier and kept me updated the whole time.",
    rating: 5,
    date: "2025-07-12"
  }
];

export const faqData = [
  {
    id: 1,
    question: "What services does ElevatED offer?",
    answer: "We provide comprehensive education consulting including university admissions guidance, career path planning, application assistance, visa support, and ongoing mentorship throughout your academic journey."
  },
  {
    id: 2,
    question: "Is the initial consultation really free?",
    answer: "Yes! We offer a complimentary initial consultation to understand your goals and explain how we can help you achieve them. There's no obligation to continue with our services."
  },
  {
    id: 3,
    question: "Which colleges and programs do you work with?",
    answer: "We partner with Granville College, Cambria College, VCCT, and Assiniboine Community College (ACC). Our programs range from Healthcare and Business to Counselling, IT, Trades, and Culinary Arts - over 90 career-focused programs in total."
  },
  {
    id: 4,
    question: "How long does the application process take?",
    answer: "The timeline varies depending on your chosen program and institution. Generally, the process takes 3-6 months from initial consultation to application submission. We recommend starting at least 8-12 months before your intended start date."
  },
  {
    id: 5,
    question: "Do you help with student visa applications?",
    answer: "Yes, we provide comprehensive visa guidance including document preparation, application submission, and interview preparation to maximize your chances of approval."
  },
  {
    id: 6,
    question: "What makes ElevatED different from other consultancies?",
    answer: "We offer personalized one-on-one mentorship, transparent guidance with no hidden fees, and ongoing support even after admission. Our success rate and student satisfaction speak for themselves."
  }
];

export const programCategories = [
  {
    id: 1,
    category: "Healthcare & Medical",
    programCount: 28,
    icon: "Heart",
    examples: "Health Care Assistant, Medical Office Assistant, Veterinary Technician"
  },
  {
    id: 2,
    category: "Business & Hospitality",
    programCount: 18,
    icon: "Briefcase",
    examples: "Accounting, Digital Business Management, Hospitality Management"
  },
  {
    id: 3,
    category: "Counselling & Mental Health",
    programCount: 12,
    icon: "Users",
    examples: "Professional Counselling, Addictions Worker, Youth & Family Support"
  },
  {
    id: 4,
    category: "Technology & IT",
    programCount: 8,
    icon: "Cpu",
    examples: "Network Support Administrator, Supply Chain Management"
  },
  {
    id: 5,
    category: "Trades & Culinary",
    programCount: 15,
    icon: "Hammer",
    examples: "Culinary Arts, Apprenticeship Programs, Agriculture & Environment"
  },
  {
    id: 6,
    category: "Community Services",
    programCount: 10,
    icon: "HeartHandshake",
    examples: "Social Services, Education Assistant, Community Support Worker"
  }
];

export { blogPosts } from './blogPosts';

export const statsData = [
  {
    value: "1000+",
    label: "Students Placed",
    icon: "Users"
  },
  {
    value: "4",
    label: "Partner Colleges",
    icon: "Building2"
  },
  {
    value: "95%",
    label: "Success Rate",
    icon: "TrendingUp"
  }
];

export const contactInfo = {
  email: "info@elevatededucation.ca",
  phone: "+1 (778) 654-8004",
  hours: "Monday - Friday: 9:00 AM - 6:00 PM EST"
};

// Language translations
export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      programs: "Programs",
      about: "About",
      blog: "Blog",
      contact: "Contact"
    },
    cta: {
      bookConsultation: "Book Free Consultation",
      learnMore: "Learn More",
      explorePrograms: "Explore Programs"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      programs: "Programmes",
      about: "À propos",
      blog: "Blog",
      contact: "Contact"
    },
    cta: {
      bookConsultation: "Réserver une consultation gratuite",
      learnMore: "En savoir plus",
      explorePrograms: "Explorer les programmes"
    }
  }
};
